import React from 'react';
import { Router } from '@abyss/web/ui/Router';
import { Login } from '@src/components/public/Login';
import { NotFound } from '@src/components/public/NotFound';
import { Layout } from '@src/components/layouts/Layout';
import { SharedLayout } from '@src/components/layouts/SharedLayout';
import { AuthenticationGuard } from './AuthenticationGuard';
import { SingleSignOn } from '@src/components/public/SingleSignOn';
import { AuthenticationError } from '@src/components/public/AuthenticationError';
import { Logout } from '@src/components/public/Logout/Logout';
import { FollowUpStatusGrid } from '@src/components/pages/Admin/FollowUpStatus/FollowUpStatusGrid';
import { FollowUpStatusDetail } from '@src/components/pages/Admin/FollowUpStatus/FollowUpStatusDetail';
import { TechnologyGrid } from '@src/components/pages/Admin/Technology/TechnologyGrid';
import { TechnologyDetail } from '@src/components/pages/Admin/Technology/TechnologyDetail/TechnologyDetail';
import { ThemeGrid } from '@src/components/pages/Admin/Theme/ThemeGrid';
import { ThemeDetail } from '@src/components/pages/Admin/Theme/ThemeDetail/ThemeDetail';
import { ResponseDetailContainer } from '@src/components/pages/Response/ResponseDetailContainer';
import { ResponseGrid } from '@src/components/pages/Response/ResponseGrid';
import { ActionGrid } from '@src/components/pages/Admin/Action/ActionGrid/ActionGrid';
import { ActionDetail } from '@src/components/pages/Admin/Action/ActionDetail/ActionDetail';
import { Impersonation } from '@src/components/pages/Admin/Impersonation/Impersonation';

export const Routes = () => {
  return (
    <Router.Routes title="Customer Technology Experience | {{title}}">
      <Router.Route
        element={
          <AuthenticationGuard requireAuth={true}>
            <Layout />
          </AuthenticationGuard>
        }
      >
        <Router.Route
          path="/admin/follow-up-status"
          element={<FollowUpStatusGrid />}
        />
        <Router.Route
          path="/admin/follow-up-status/detail/:id"
          element={<FollowUpStatusDetail />}
        />
        <Router.Route path="/impersonation" element={<Impersonation />} />
        <Router.Route path="/admin/technology" element={<TechnologyGrid />} />
        <Router.Route
          path="/admin/technology/:id"
          element={<TechnologyDetail />}
        />
        <Router.Route path="/admin/theme" element={<ThemeGrid />} />
        <Router.Route path="/admin/theme/:id" element={<ThemeDetail />} />
        <Router.Route
          path="/responses/:id"
          element={<ResponseDetailContainer />}
        />
        <Router.Route
          path="/responses/:id/tab/:tabId"
          element={<ResponseDetailContainer />}
        />
        <Router.Route path="/responses" element={<ResponseGrid />} />
        <Router.Route path="/admin/action" element={<ActionGrid />} />
        <Router.Route path="/admin/action/:id" element={<ActionDetail />} />
      </Router.Route>
      <Router.Route
        element={
          <AuthenticationGuard requireAuth={false}>
            <SharedLayout />
          </AuthenticationGuard>
        }
      >
        <Router.Route path="/login" element={<Login />} />
        <Router.Route path="/" element={<Login />} />
        <Router.Route path="/sso" element={<SingleSignOn />} />
        <Router.Route
          path="/not-authenticated"
          element={<AuthenticationError />}
        />
        <Router.Route path="/logout" element={<Logout />} />
        <Router.Route path="*" element={<NotFound />} />
      </Router.Route>
    </Router.Routes>
  );
};
